import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IFlowStepProps } from '@folx-types/flow-steps';

import PostSubmitStep, { ISubmitContent } from './PostSubmitStep.component';

interface IPostSubmitStepPageProps extends IFlowStepProps {
	paymentState?: string;
}

const PostSubmitStepPage: FC<IPostSubmitStepPageProps> = ({ stepKey, path, paymentState }) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "post-submit-payment-step" }) {
				generic_error_message
				please_wait_message
			}
		}
	`);

	const refinedContent: ISubmitContent = keysToCamel(pageContent) as ISubmitContent;

	return (
		<PostSubmitStep
			stepKey={stepKey}
			path={path}
			refinedContent={refinedContent}
			paymentState={paymentState}
		/>
	);
};

export default PostSubmitStepPage;
